document.addEventListener("DOMContentLoaded", () => {
    let brand = document.querySelector('.brand-slide');
    if (brand) {
        let objectSlider = new Brands(brand);
        objectSlider.init();
    }
});

class Brands {
    constructor(brand) {
        this.slider = brand;
        this.slider_wrap = brand.querySelector('.brand-wrap');
        this.slider_items = brand.querySelectorAll('.brand-item');
        this.count_slider_items = this.slider_items.length;
        this.index = 0;
        this.animate = false;
    }

    init() {
        let that = this;
        setTimeout(() => {
            that.slide();
        }, 3000);
    }

    slide() {
        this.slider_items[this.index].classList.remove('no-transition');
        this.slider_items[this.index].style.marginLeft = '-200px';
        let that = this;
        setTimeout(() => {
            that.slider_items[that.index].classList.add('no-transition')
            that.slider_items[that.index].style.marginLeft = '0';
            that.slider_wrap.appendChild(that.slider_items[that.index]);
            that.index = (that.index + 1) > that.count_slider_items - 1 ? 0 : (that.index + 1);
            that.slide();
        }, 3000);
    }
}
